import { createFileRoute, redirect } from '@tanstack/react-router';
import { ChangePasswordScreen } from '@/features/onboarding/ChangePasswordScreen';
import { sessionQuery } from '@/lib/session';

export const Route = createFileRoute('/change-password')({
  // Mirrors the backend's PasswordGate (bypass={password, tos, onboarding}):
  // reachable regardless of which of those gates is active, but NOT during
  // the decline-grace window (docs/parity/auth-public.md §2.6, §8#5 - a
  // declined user can only accept updated terms or export-and-sign-out).
  //
  // FIX (reviewer pass): must-change-password outranks decline-grace in the
  // legacy gate chain (§3 "gate precedence" - the real _auth_gate never even
  // reaches its decline-grace step while must_change_password is set, since
  // step 3 intercepts first). The original guard here redirected to
  // /account-closed whenever account_closed was true, with no exception for
  // a user who ALSO owes a password change (e.g. an admin password-resets a
  // declined-grace user). That combined state is reachable in production and
  // produced a genuine redirect loop: gateRoute() sends such a user TO
  // /change-password (password_change_required wins there), this guard then
  // bounced them back OUT to /account-closed, whose own guard reads
  // gateRoute() again, gets '/change-password', and sends them right back -
  // the exact class of ping-pong bug docs/parity/auth-public.md §3/§8#4
  // warns the rebuild not to reintroduce. Only bounce to /account-closed
  // when the password gate is NOT also active.
  beforeLoad: async ({ context }) => {
    const s = await context.queryClient.ensureQueryData(sessionQuery);
    if (!s.authenticated) throw redirect({ to: '/login' });
    if (!s.gates?.password_change_required && s.gates?.account_closed) {
      throw redirect({ to: '/account-closed' });
    }
  },
  component: ChangePasswordScreen,
});
